import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./utils/store/store";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./css/tailwind.css";
import moment from "moment";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./utils/auth/authConfig";

// Polyfill Buffer for @react-pdf/renderer
import { Buffer } from 'buffer';

// Make Buffer available globally
if (typeof window !== 'undefined') {
  (window as any).Buffer = Buffer;
  (window as any).global = window;
  (window as any).process = { env: {} };
}

export const DATE_FORMAT = "MMMM DD, YYYY";
export const EMAIL_REGEX =
  /^[^(),:;<>@[\]]+@{1}[^(),:;<>@[\]]+\.+[A-Z 1-9-]+$/i;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

moment.updateLocale("en", {
  relativeTime: {
    future: "in %s",
    past: "%s ago",
    s: "a few seconds",
    ss: "%d seconds",
    m: "a minute",
    mm: "%d minutes",
    h: "an hour",
    hh: "%d hours",
    d: "a day",
    dd: "%d days",
    w: "a week",
    ww: "%d weeks",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years"
  }
});

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL before rendering the app
msalInstance.initialize().then(() => {
  // Render the React app in the root element
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <Provider store={store}>
            <App />
          </Provider>
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>
  );
});

